//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

  data: function () {

    return {

      variants: [],

      prevSearch: "",

      isOpen: false,
      isLoading: false,
      isDisabled: false,

    };

  },

  props: {

    groupId: {
      type: Number,
      default: 0
    },
    isScrolled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: ''
    },

    prevGroupName: {
      type: String,
      default: ''
    },

    initVariants: {
      type: Array,
      default: () => {
        return []
      }
    },

    isFirst: {
      type: Boolean,
      default: false
    },

    available: {
      type: Boolean,
      default: false
    },

    selected: {
      type: Object,
      default: () => {
        return {}
      }
    },

    productId: {
      type: Number,
      default: 0
    }

  },

  mounted() {
    if (this.isFirst) {
      this.variants = this.initVariants;
    }
    if (this.name === 'items_in_pack') {
      const _variant = this.initVariants?.[0]
      this.setVariant(_variant);
    }

  },

  computed: {

    valueLabel: function () {
      return this.selected?.[this.groupId]?.label || this.selected?.[this.groupId]?.value || 'Выберите';
    },

    isOpacitySelect: function () {
      return Boolean(this.isDisabled || this.selected?.[this.groupId]?.id === -1)
    },

    innerWidth: function () {
      if (process.client) {
        return window.innerWidth
      }
      return 1920
    }

  },

  watch: {
    valueLabel: function () {
      this.isDisabled = false;
    },

    available: async function () {
      if (this.innerWidth > 991 && !this.selected) {
        await this.openVariants();
      }
    },
  },

  methods: {

    openVariants: async function () {
      if (!this.available) {
        return null
      }
      if (this.isFirst) {
        this.isOpen = true;
        return null
      }

      const search = Object.keys(this.selected).filter((key) => +key !== +this.groupId)
        .map((key) => Boolean(this.selected[key]?.id !== -1) ? `variant_ids[]=${this.selected[key]?.id}` : null)
        .filter((t) => !!t)
        .join('&');
      if (this.prevSearch === `${this.groupId}?${search}`) {
        this.isOpen = true;

        return null
      }

      this.isLoading = true;
      const {data} = await this.$api.agent.transport.get(`/products-local/${this.productId}/modification-variants/${this.groupId}?${search}`).catch((err) => {
        return {data: undefined}
      });
      const variants = data?.variants?.variants || this.variants || [];
      const isExist = data?.exist;

      this.prevSearch = `${this.groupId}?${search}`;
      this.variants = variants;
      this.isLoading = false;


      if (variants.length <= 0 && isExist) {
        this.setVariant({id: -1, label: "Недоступно"});
        this.isDisabled = true;
        return
      }
      if (variants.length === 1) {
        this.setVariant(variants?.[0]);
        return
      }
      this.isOpen = true;
    },

    setVariant: function (variant) {
      this.$emit("change", variant);
      this.isOpen = false;

    }

  }

};
